module.exports = __webpack_public_path__ + "static/media/engie.8fa6943e.png";